import { staffCheckApi } from "@/api/makeUpLessons";
import { Message } from "element-ui";
export async function schedulePrint(originData: {
  lessons: any[];
  classrooms: any[];
  timeRange: string[];
}) {
  // 打印权限
  try {
    const res: any = await staffCheckApi({
      api_path: ["/print/class/schedule"],
    });
    if (res.error_code === 0) {
      if (!res.data["/print/class/schedule"]) {
        Message({
          message: "无打印权限",
          type: "warning",
        });
        return false;
      }
    } else {
      Message({
        message: res.message,
        type: "warning",
      });
      return false;
    }
  } catch {
    Message({
      message: "打印请求出错",
      type: "warning",
    });
    return false;
  }
  // 处理数据
  const orgCache = localStorage.getItem("userInfo");
  const orgName = orgCache ? JSON.parse(orgCache).org_name : "音乐窝中心";
  const pageWidthLimit = 1040 - 36; // 最大宽度1040 - 时间轴宽度36
  const lessonItemMinWidth = 111; // 课时组件最低宽度
  const textBaseWidth = 12; // 单字宽度，无视数字英语按汉字来算
  const tableList: any[] = [];
  // 先将每日每个课时设置为1列，填充课时，宽度为colWidth，将全部列保存为一个数组
  const classRoomList: any[] = [];
  originData.lessons.forEach((date) => {
    originData.classrooms.map((classroom) => {
      const lList = date.lesson_list.filter((lesson: any) => {
        if (lesson.classroom) {
          return lesson.classroom.classroom_id === classroom.classroom_id;
        } else {
          // 课次classroom可能为null
          return false;
        }
      });
      // console.log(lList);
      // debugger
      // 找到当天当课室内，单个小时内最大课时数（排课冲突时会大于1）
      const obj: any = {};
      lList.forEach((lesson: any) => {
        const start = lesson.start_time.slice(0, 2);
        if (obj[start]) {
          obj[start] = obj[start] + 1;
        } else {
          obj[start] = 1;
        }
      });
      const arr = [];
      for (const key in obj) {
        arr.push(obj[key]);
      }
      let colw = 0;
      if (arr.length === 0) {
        // 当日当课室课时为空，列宽度设置为标题宽度，+1border
        colw = classroom.name.length * textBaseWidth + 1;
      } else {
        // 有课时时，宽度为最大课时数乘课时组件宽度
        colw = Math.max(...arr) * lessonItemMinWidth;
      }
      // console.log(arr);
      // debugger
      classRoomList.push({
        date: date.date,
        id: classroom.classroom_id,
        name: classroom.name,
        lessonList: lList,
        colWidth: colw,
        // flex: arr.length===0?0:Math.max(...arr)
      });
    });
  });
  // console.log(classRoomList);
  // 然后遍历列数组，根据每列宽度总和分页
  let pageWidthMark = 0;
  let pageContent: any[] = [];
  classRoomList.forEach((classroom, index) => {
    pageContent.push(classroom);
    pageWidthMark = pageWidthMark + classroom.colWidth;
    if (pageWidthMark >= pageWidthLimit) {
      tableList.push(pageContent);
      pageContent = [];
      pageWidthMark = 0;
      return;
    }
    if (classRoomList[index + 1]) {
      // 注意边界，下一列宽度加上本页宽度的话，则要提前分页
      if (pageWidthMark + classRoomList[index + 1].colWidth > pageWidthLimit) {
        tableList.push(pageContent);
        pageContent = [];
        pageWidthMark = 0;
      }
    } else {
      // 最后一列
      tableList.push(pageContent);
      pageContent = [];
      pageWidthMark = 0;
    }
  });
  // console.log(tableList);
  // 课表起点和终点
  const scheduleStart = Number(originData.timeRange[0].slice(0, 2));
  const scheduleEnd = Number(originData.timeRange[1].slice(0, 2));
  // 创建iframe和style
  const iframeEle = document.createElement("iframe");
  iframeEle.style.display = "none";
  // iframeEle.style.position = 'fixed';
  // iframeEle.style.zIndex = '10000';
  // iframeEle.style.top = '0';
  // iframeEle.style.left = '0';
  // iframeEle.style.height = '100%';
  // iframeEle.style.width = '100%';
  // iframeEle.style.backgroundColor = '#fff';
  document.body.appendChild(iframeEle);
  const content = iframeEle.contentWindow;
  const style = document.createElement("style");
  style.type = "text/css";
  style.innerHTML = `
      body{
        margin:0;
        height:99%;
      }
      p{
        font-size:12px;
        margin:0;
        color:#000;
        line-height:17px;
      }
      .table{
        border:1px solid;
        width:1040px;
        overflow:hidden;
        height:100%;
        display:flex;
        flex-direction: column;
      }
      .table-header{
        height:17px;
        text-align:center;
        border-bottom:1px solid;
      }
      .table-body{
        flex:1;
        display:flex;
      }
      .table-body .time-line{
        width:36px;
        border-right:1px solid;
        display:flex;
        flex-direction: column;
      }
      .table-body .time-line .block{
        height:17px;
        border-bottom:1px solid;
      }
      .table-body .time-line .hour{
        flex:1;
        text-align:center;
        border-bottom:1px solid;
        padding:0 2px;
        display: flex;
        align-items: center;
      }
      .table-body .time-line .hour p{}
      .table-body .time-line .hour:last-child{
        border-bottom:0;
      }
      .table-body .date-list{
        border-right:1px solid;
        flex:1;
        display:flex;
        flex-direction: column;
      }
      .table-body .date-list:last-child{
        border-right:0;
      }
      .table-body .date-list .date{
        border-bottom:1px solid;
        text-align:center;
      }
      .table-body .date-list .classroom-list{
        display:flex;
        flex:1;
      }
      .table-body .date-list .classroom-list .classroom{
        border-right:1px solid;
        flex:1;
        white-space: nowrap;
        display:flex;
        flex-direction: column;
      }
      .table-body .date-list .classroom-list .classroom:last-child{
        border-right:0;
      }
      .table-body .date-list .classroom-list .classroom .classroom-name{
        border-bottom:1px solid;
        text-align:center;
        height:17px;
      }
      .table-body .date-list .classroom-list .classroom .lesson-list{
        flex:1;
        overflow:hidden;
        border-bottom:1px solid;
        display: flex;
      }
      .table-body .date-list .classroom-list .classroom .lesson-list:last-child{
        border-bottom: 0;
      }
      .table-body .date-list .classroom-list .classroom .lesson-list .lesson{
        text-align:center;
        width:111px;
        flex:1;
        overflow:hidden;
        padding:0 2px;
        border-right:1px solid;
      }
      .table-body .date-list .classroom-list .classroom .lesson-list .lesson:last-child{
        border-right:0;
      }
      .table-body .date-list .classroom-list .classroom .lesson-list .lesson .content{
        width:100%;
        transform:translate3d(0,-50%,0) scale(0.9);
        transform-origin: center center;
        position:relative;
        top:50%;
      }
      .table-body .date-list .classroom-list .classroom .lesson-list .lesson p{
        line-height:13px;
        font-size:12px;
      }
      .table-body .date-list .classroom-list .classroom .lesson-list .lesson p:last-child{
        white-space: normal;
        overflow:hidden;
        word-break: break-all;
        text-overflow:ellipsis;
        -webkit-line-clamp:2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
      @media print {
        .table {
          page-break-after: always;
        }
      }
    `;
  content?.document.getElementsByTagName("head")[0].appendChild(style);
  // 表格内容
  // console.log(tableList);
  tableList.map((page) => {
    const table = document.createElement("div");
    // 时间轴
    let timeLine = "";
    for (let i = scheduleStart; i < scheduleEnd + 1; i++) {
      timeLine =
        timeLine +
        `<div class="hour">
          <p>${i < 10 ? "0" + i : i}:00</p>  
        </div>`;
    }
    // 日期结构
    let dateHTML = "";
    let dateWidth = 0;
    let classroomHTML = "";
    page.forEach((classroom: any, index: number) => {
      dateWidth = dateWidth + classroom.colWidth;
      let lessonHtml = "";
      for (let i = scheduleStart; i < scheduleEnd + 1; i++) {
        const match = classroom.lessonList.filter((lesson: any) => {
          const hour = Number(lesson.start_time.slice(0, 2));
          return hour >= i && hour < i + 1;
        });
        if (match) {
          // 排课错误的情况下同一个时间段内同一个课室可能有多个课时
          lessonHtml = lessonHtml + '<div class="lesson-list">';
          match.map((lesson: any) => {
            lessonHtml =
              lessonHtml +
              `<div class="lesson">
                <div class="content">
                  <p>${lesson.start_time.slice(0, 5)} - ${lesson.end_time.slice(
                0,
                5
              )}</p>
                  <p>${lesson.course.title}</p>
                  <p>${lesson.teacher_list
                    .map((t: any) => {
                      return t.name;
                    })
                    .join(",")}</p>
                </div>
              </div>`;
          });
          lessonHtml = lessonHtml + "</div>";
        } else {
          lessonHtml = lessonHtml + '<div class="lesson-list"></div>';
        }
      }
      classroomHTML =
        classroomHTML +
        `<div class="classroom" style="width:${classroom.colWidth}px">` +
        `<p class="classroom-name">${classroom.name}</p>` +
        lessonHtml +
        "</div>";
      if (index === page.length - 1) {
        dateHTML =
          dateHTML +
          `<div class="date-list" style="flex:${dateWidth}"><p class="date">${classroom.date}</p><div class="classroom-list">` +
          classroomHTML +
          "</div></div>";
        dateWidth = 0;
        classroomHTML = "";
      } else {
        if (classroom.date !== page[index + 1].date) {
          dateHTML =
            dateHTML +
            `<div class="date-list" style="flex:${dateWidth}"><p class="date">${classroom.date}</p><div class="classroom-list">` +
            classroomHTML +
            "</div></div>";
          dateWidth = 0;
          classroomHTML = "";
        }
      }
    });
    table.className = "table";
    table.innerHTML =
      `
        <p class="table-header">${orgName}课表</p>
        <div class="table-body">
          <div class="time-line">
            <div class="block"></div>
            <div class="block"></div>
            ` +
      timeLine +
      `
          </div>
          ` +
      dateHTML +
      `
        </div>
      `;
    content?.document.body.appendChild(table);
  });
  content?.focus();
  content?.print();
  document.body.removeChild(iframeEle);
}
